// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__DOjTb","image":"App_image__hV4NJ"};